import React from "react";
import ComboCard from "./ComboCard";

export const ComboSection = ({ sections = {}, combos = [], byCombo = {}, basisLabel = "per tablet" }) => {
    if (!combos.length) return null;
    return (
        <section className="mx-auto max-w-7xl px-6 md:px-12 mt-12 md:mt-16" data-testid="combo-section">
            <div className="max-w-2xl">
                <div className="eyebrow mb-3">{sections.combo_subtitle || "Formulation"}</div>
                <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tight">
                    {sections.combo_title || "Powerful Combos"}
                </h2>
                {sections.combo_body && <p className="mt-5 text-zinc-400 leading-relaxed">{sections.combo_body}</p>}
            </div>

            <div className="mt-12 grid md:grid-cols-3 gap-5 items-start">
                {combos.map((combo, i) => (
                    <ComboCard key={combo.id} combo={combo} index={i}
                        ingredients={byCombo[combo.id] || []} basisLabel={basisLabel} />
                ))}
            </div>
        </section>
    );
};

export default ComboSection;
